export default __webpack_public_path__ + "imgs/imageStep3.png";